var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('div',[_c('v-card-title',[_vm._v(" Pedidos ")]),_c('v-divider'),_c('div',{staticClass:"pa-4 d-flex flex-column"},[_c('ListaPedidosContainer',{attrs:{"admin":""}})],1)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }